import { Map } from 'immutable';
import * as relocation from '../../actions/relocation/relocationDetails';

const initialState = Map({
  RelocationDetailsList: {},
});

const actionsMap = {
  [relocation.GET_RELOCATION_DETAILS]: (state, action) => {
    return state.set('RelocationDetailsList', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}